import React from "react";
import { useMemo } from "react";
import { InputGroup, Input, Progress } from "reactstrap";
export const Rating = React.memo(
  function Rating(props) {
    const {
      ratingValue,
      ratingType,
      readOnly,
      setRatingValue,
      lecturerIndex,
      numberOfRatings,
      disabled
    } = props;

    const handleChange = (e, i) => {
      //console.log("value of i", i);
      setRatingValue(i, lecturerIndex);
    };

    const ratingJSX = () => {
      // //console.log(ratingValue);
      let returnJsx = [];
      let id;
      for (let i = 1; i <= 5; i++) {
        id = Date.now() + i;
        returnJsx.push(
          <Input
    
            required={i === 1 ? true : false}
            form={`form-${lecturerIndex}`}
            key={id}
            type="checkbox"
            name={ratingType}
            id={id}
            checked={ratingValue >= i ? true : false}
            readOnly={readOnly}
            style={{ cursor: "pointer",  fontSize: "1.4rem",}}
            onChange={(e) => handleChange(e, i)}
            disabled={disabled? true : false}
          ></Input>
        );
      }

      return returnJsx;
    };

 

    const progressJsx = useMemo(() => {
      let returnJsx = [];
      const colors  = [
        "#ffba08",
        "#faa307",
        "#f48c06",
        "#e85d04",
        "#dc2f02"
      ]      
      //  make 5 progress bars
      // fill each according to the ratingValue
      // make the progress bar fill according the ratingValue
      let ratingValueTemp = ratingValue;
      for (let i =0; i < 5 ; i++, ratingValueTemp--) {
        if (ratingValueTemp < 0) {
          ratingValueTemp = 0;
        }
        returnJsx.push(
          <Progress
            key={i}
            barStyle= {{
              backgroundColor: colors[i],

            }}
            value={Math.min(ratingValueTemp, 1)}
            max={5}
            bar
          ></Progress>
        );
      }

      return returnJsx;
    }, [ratingValue]);

    return (
      <div>
        {/* explanation form */}

        {readOnly ? (
          <>
            <div className="text-center">
            {ratingValue.toFixed(1)}/5 <small className="text-muted">({numberOfRatings} {
              numberOfRatings === 1 ? "rating" : "ratings"})</small>
  </div>
          <Progress 
          style={{
            height: "1.75rem",
          }}
          multi>
            {progressJsx}
            
            
            
            </Progress>




          </>
        ) : (
          <div >
            <InputGroup
              className="justify-content-center flex-nowrap"
            >{ratingJSX()}</InputGroup>
          </div>
        )}
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.ratingValue === nextProps.ratingValue &&
      prevProps.setRatingValue === nextProps.setRatingValue &&
      prevProps.lecturerIndex === nextProps.lecturerIndex &&
      prevProps.disabled === nextProps.disabled
    );
  }
);
